import { Permission } from '@rivethealth/data/user-account';

export const Permissions: { [key in Permission]: key } = {
  payer_payer_view: 'payer_payer_view',
  payer_payer_edit: 'payer_payer_edit',
  payer_contract_view: 'payer_contract_view',
  payer_contract_edit: 'payer_contract_edit',
  payer_claim_view: 'payer_claim_view',
  payer_claim_edit: 'payer_claim_edit',
  patient_view: 'patient_view',
  patient_edit: 'patient_edit',
  patient_eligibility_view: 'patient_eligibility_view',
  patient_eligibility_edit: 'patient_eligibility_edit',
  patient_eligibility_settings_edit: 'patient_eligibility_settings_edit',
  patient_estimate_view: 'patient_estimate_view',
  patient_estimate_edit: 'patient_estimate_edit',
  patient_estimate_collections_total_view:
    'patient_estimate_collections_total_view',
  patient_appointment_view: 'patient_appointment_view',
  patient_payer_crosswalk_view: 'patient_payer_crosswalk_view',
  patient_payer_crosswalk_edit: 'patient_payer_crosswalk_edit',
  patient_payment_view: 'patient_payment_view',
  patient_payment_edit: 'patient_payment_edit',
  practice_business_unit_view: 'practice_business_unit_view',
  practice_business_unit_edit: 'practice_business_unit_edit',
  practice_chargemaster_view: 'practice_chargemaster_view',
  practice_chargemaster_edit: 'practice_chargemaster_edit',
  practice_utilization_view: 'practice_utilization_view',
  practice_utilization_edit: 'practice_utilization_edit',
  practice_provider_view: 'practice_provider_view',
  practice_provider_edit: 'practice_provider_edit',
  practice_file_view: 'practice_file_view',
  practice_file_edit: 'practice_file_edit',
  practice_service_department_view: 'practice_service_department_view',
  practice_service_department_edit: 'practice_service_department_edit',
  practice_integration_view: 'practice_integration_view',
  practice_integration_edit: 'practice_integration_edit',
  analytics_top_payers_view: 'analytics_top_payers_view',
  analytics_top_payers_export: 'analytics_top_payers_export',
  analytics_super_score_view: 'analytics_super_score_view',
  analytics_super_score_export: 'analytics_super_score_export',
  analytics_fee_schedule_evolution_view:
    'analytics_fee_schedule_evolution_view',
  analytics_fee_schedule_evolution_export:
    'analytics_fee_schedule_evolution_export',
  analytics_renewals_expirations_view: 'analytics_renewals_expirations_view',
  analytics_renewals_expirations_export:
    'analytics_renewals_expirations_export',
  underpayments_view: 'underpayments_view',
  underpayments_export: 'underpayments_export',
  underpayments_statuses_view: 'underpayments_statuses_view',
  underpayments_statuses_edit: 'underpayments_statuses_edit',
  analytics_contract_terms_view: 'analytics_contract_terms_view',
  analytics_contract_terms_export: 'analytics_contract_terms_export',
  analytics_all_codes_view: 'analytics_all_codes_view',
  analytics_all_codes_export: 'analytics_all_codes_export',
  analytics_top_codes_view: 'analytics_top_codes_view',
  analytics_top_codes_export: 'analytics_top_codes_export',
  analytics_pricing_optimization_view: 'analytics_pricing_optimization_view',
  analytics_pricing_optimization_export:
    'analytics_pricing_optimization_export',
  analytics_procedure_comparison_view: 'analytics_procedure_comparison_view',
  analytics_procedure_comparison_export:
    'analytics_procedure_comparison_export',
  analytics_estimates_view: 'analytics_estimates_view',
  analytics_estimates_export: 'analytics_estimates_export',
  analytics_market_score_view: 'analytics_market_score_view',
  analytics_market_score_export: 'analytics_market_score_export',
  workflows_pricing_optimization_edit: 'workflows_pricing_optimization_edit',
  workflows_modeler_edit: 'workflows_modeler_edit',
  workflows_modeler_claim_volume_edit: 'workflows_modeler_claim_volume_edit',
  underpayments_edit: 'underpayments_edit',
  work_communication_view: 'work_communication_view',
  work_communication_create: 'work_communication_create',
  work_communication_delete: 'work_communication_delete',
  work_activity_view: 'work_activity_view',
  delete_comment: 'delete_comment',
  settings_account_info_view: 'settings_account_info_view',
  settings_account_info_edit: 'settings_account_info_edit',
  settings_user_view: 'settings_user_view',
  settings_user_edit: 'settings_user_edit',
  settings_appointments_view: 'settings_appointments_view',
  settings_appointments_edit: 'settings_appointments_edit',
  integrations_personal_email_edit: 'integrations_personal_email_edit',
  claims_analytics_view: 'claims_analytics_view',
  claims_analytics_edit: 'claims_analytics_edit',
  claims_analytics_export: 'claims_analytics_export',
  denials_settings_view: 'denials_settings_view',
  denials_settings_edit: 'denials_settings_edit',
  denials_worklist_view: 'denials_worklist_view',
  denials_worklist_edit: 'denials_worklist_edit',
  denials_worklist_export: 'denials_worklist_export',
  denials_auto_assignment_view: 'denials_auto_assignment_view',
  denials_auto_assignment_edit: 'denials_auto_assignment_edit',
  denials_instructions_view: 'denials_instructions_view',
  denials_instructions_edit: 'denials_instructions_edit',
  denials_productivity_view: 'denials_productivity_view',
  denials_productivity_edit: 'denials_productivity_edit',
  denials_productivity_analytics_view: 'denials_productivity_analytics_view',
  denials_productivity_analytics_edit: 'denials_productivity_analytics_edit',
  denials_statuses_view: 'denials_statuses_view',
  denials_statuses_edit: 'denials_statuses_edit',
  denials_payment_issue_edit: 'denials_payment_issue_edit',
  denials_payment_issue_view: 'denials_payment_issue_view',
  denials_forms_view: 'denials_forms_view',
  denials_forms_edit: 'denials_forms_edit',
  denials_automations_view: 'denials_automations_view',
  denials_automations_edit: 'denials_automations_edit',
  nonresponse_worklist_view: 'nonresponse_worklist_view',
  nonresponse_worklist_edit: 'nonresponse_worklist_edit',
  nonresponse_worklist_export: 'nonresponse_worklist_export',
  nonresponse_claim_status_check_automatic_view:
    'nonresponse_claim_status_check_automatic_view',
  nonresponse_claim_status_check_automatic_edit:
    'nonresponse_claim_status_check_automatic_edit',
  nonresponse_claim_status_check_manual_edit:
    'nonresponse_claim_status_check_manual_edit',
  hospital_estimate_edit: 'hospital_estimate_edit',
  estimate_template_edit: 'estimate_template_edit',
  service_template_edit: 'service_template_edit',
  note_template_edit: 'note_template_edit',
  estimates_automation_edit: 'estimates_automation_edit',
  shared_filter_edit: 'shared_filter_edit',
  machine_readable_file_view: 'machine_readable_file_view',
  machine_readable_file_edit: 'machine_readable_file_edit',
  self_serve_estimator_view: 'self_serve_estimator_view',
  self_serve_estimator_edit: 'self_serve_estimator_edit',
  settings_permissions_edit: 'settings_permissions_edit',
  settings_permissions_view: 'settings_permissions_view',
  revenue_diagnostics_view: 'revenue_diagnostics_view',
  revenue_diagnostics_export: 'revenue_diagnostics_export',
  benchmark_view: 'benchmark_view',
  benchmark_export: 'benchmark_export',
  nexus_understand_view: 'nexus_understand_view',
  nexus_understand_export: 'nexus_understand_export',
  prevent_view: 'prevent_view',
  prevent_export: 'prevent_export',
};

export const ALL_PERMISSIONS: Permission[] = Object.values(Permissions);
